
import { Chip, Divider, Grid2, Typography, useTheme } from '@mui/material'
import React, { FC, ReactNode, useEffect, useState } from 'react'
import { Button } from '../../../Form/Button/button.scomponent'
import { GoPlus } from 'react-icons/go'
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { Input } from '../../../Form/Input/input.component';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup'
import { Switch } from '../../../Form/Switch/switch.component';
import { IOptionsProps, SelectComponent } from '../../../Form/Select/select.component';
import { Flex } from '../../../Flex/flex.component';
import { FaChevronLeft, FaTrash } from 'react-icons/fa';
import { ListProductVariantsServiceUseCase } from '../../../../Usecase/ProductVariants/list-product-variants-usecase';
import { useToast } from '../../../../Hooks/ToasContext';
import { Radio } from '../../../Form/Radio/radio-input.component';

interface IVariation {
  variationType: string;
  values: string[];
  howManySteps?: string;
}

interface ProductProps {
    name: string;
    code: string;
    ncm: string;
    personalized: boolean
    createOnNuvemShop: boolean;
    createOnOmie: boolean;
    createOnb2b: boolean;
    createOnb2c: boolean;
    price: string
    description: string
  }
  
  
const SignInSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    code: Yup.string(),
    ncm: Yup.string(),
    personalized: Yup.boolean(),
    createOnNuvemShop: Yup.boolean(),
    createOnOmie: Yup.boolean(),
    price: Yup.string().required('Preço Unitário é obrigatório'),
    description: Yup.string(),
    createOnb2b: Yup.boolean(),
    createOnb2c: Yup.boolean(),
  });

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  
interface IDrawerComponent extends DrawerProps {
    onToggle: (state: boolean) => void;
    title: string;
    subTitle?: string;
    search?: boolean;
    searchFunction?: () => void;
    titleStyle?: object
    subTitleStyle?: object
    open: boolean;
    handleSelect: (variation: IVariation) => void;
    listProductVariantsServiceUseCase: ListProductVariantsServiceUseCase
    variations?: IVariation[];
    onAddVariation?: (variationType: string, values: string[], howManySteps: string) => void;
    onRemoveVariation?: (variationType: string) => void;
    onRemoveValue?: (variationType: string, value: string) => void;
}

const VariantsListDrawer : FC<IDrawerComponent> = ({ 
  onToggle, 
  title, 
  subTitle, 
  open, 
  titleStyle = {}, 
  subTitleStyle = {}, 
  handleSelect, 
  listProductVariantsServiceUseCase,
  variations = [],
  onAddVariation,
  onRemoveVariation,
  onRemoveValue
}) => {
  const [newVariation, setNewVariation] = useState(false)
  const [loading, setLoading] = useState(false)
  const [variantSelected, setVariantSelected] = useState('')
  const [variantsOptions, setVariantsOptions] = useState<IOptionsProps[]>([])
  const [selectedValue, setSelectedValue] = useState<string>('')
  const [howManyQuantityVariantSteps, setHowManyQuantityVariantSteps] = useState<string>('')
  const { showToast } =  useToast()
  
    const theme = useTheme();
    const { handleSubmit, register, control, formState, reset } = useForm<any>({
        resolver: yupResolver(SignInSchemaValidation),
      });

      const { errors } =  formState;

    const handleListProductVariants = async () => {
        
      try {
        setLoading(true)
        
        const listResult = await listProductVariantsServiceUseCase.handle();

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const list = listResult.getValue()

        if(list?.variantNames?.length){
          const normalize = list.variantNames.map(i => ({
            value: i,
            label: i
          }))?.filter(i => i.label === 'QUANTIDADE')
            setVariantsOptions(normalize)
        }

      } catch (error) {
        console.log("error handleListProductsServices function: ", error)
      } finally {
        setLoading(false);
      }
  };

  useEffect(() => {
    handleListProductVariants()
  }, [])

  const handleValueSelection = (value: string | number) => {
    setSelectedValue(String(value));
  };

  const handleHowManyQuantityVariantStepsSelection = (value: string | number) => {
    setHowManyQuantityVariantSteps(String(value));
  };

  const handleSaveVariation = () => {
    if(!variantSelected || !selectedValue){
      showToast('Selecione o Multiplicador de unidade de cubagemm mínima', 'error');
      return;
    }
    if(!howManyQuantityVariantSteps){
      showToast('Selecione quantas variações de quantidade deseja criar', 'error');
      return;
    }
    if (variantSelected && selectedValue && onAddVariation && howManyQuantityVariantSteps) {
      onAddVariation(variantSelected, [selectedValue], howManyQuantityVariantSteps);
      // Reset form
      setVariantSelected('');
      setSelectedValue('');
      setHowManyQuantityVariantSteps('');
      setNewVariation(false);
      reset();
    }
  };

  const handleRemoveVariationClick = (variationType: string) => {
    if (onRemoveVariation) {
      onRemoveVariation(variationType);
    }
  };

  const handleRemoveValue = (variationType: string, value: string) => {
    if (onRemoveValue) {
      onRemoveValue(variationType, value);
    }
  };

  const getVariationOptions = (variantType: string) => {
    switch(variantType) {
      case 'QUANTIDADE':
        return ['x1','x2','x3','x4','x5','x6','x7','x8','x9','x10'];
      case 'COR':
        return ['Branco','Preto', 'Amarelo','Azul','Azul Claro', 'Bege','Cinza','Laranja','Marrom','Pink','Prata','Rosa','Roxo','Verde','Vermelho','Vinho'];
      case 'SACOLAS':
          return ['Sacola teste 1', 'Sacola teste 2', 'Sacola teste 3'];
      case 'VOLTAGE':
        return ['110V','220V'];
      case 'volume1':
        return ['1500 ML'];
      case 'volume2':
        return ['210 ML'];
      default:
        return [];
    }
  };

    return (
        <Drawer open={open} onClose={onToggle} anchor='right' style={{ zIndex: 99999999 }} sx={{ '& .MuiDrawer-paper': { overflowY: 'auto' }}}>
          {newVariation ? (
            <Grid2 sx={{ minWidth: '650px', padding: '30px 30px'}} >

              <Button onClick={() => setNewVariation(false)} variant='text' LeftIcon={() => <FaChevronLeft size={18}/>} textSx={{ marginLeft: '-10px'}} sx={{ marginBottom: '20px', width: '150px'}}>
                Voltar
              </Button>
            
                <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', ...titleStyle}} >Nova Variação</Typography> 
                
            
               
                {subTitle && <Typography sx={{ fontSize: '1rem', fontWeight: '400', color: theme.palette.text.secondary,  ...subTitleStyle}} >Selecione a variação abaixo</Typography> }

                <Grid2 size={12} sx={{ marginTop: '20px'}}>
                  <SelectComponent 
                    name='variation' 
                    label='Variação' 
                    options={variantsOptions} 
                    control={control} 
                    error={!!errors.customer_marital_status} 
                    helperText={errors?.customer_marital_status?.message || ''} 
                    onChangeCallback={e => setVariantSelected(e)} 
                    placeholder=''
                  />
                </Grid2>

                <Grid2 size={12} mt={2}>
                  {!!variantSelected && (
                    <>
                    
                      
                      <Radio
                        label="Multiplicador de unidade de cubagemm mínima"
                        name="variation-options"
                        control={control}
                        options={getVariationOptions(variantSelected).map(item => ({
                          label: item,
                          value: item
                        }))}
                        onChangeCallback={handleValueSelection}
                        defaultValue={selectedValue}
                      />
                    

                      <Divider sx={{ marginTop: '20px', marginBottom: '20px'}} />

                      <Radio
                        label="Criar quantas variações?"
                        name="howManyQuantityVariantSteps"
                        control={control}
                        options={[{ label: '1', value: '1' }, { label: '40', value: '40' }]}
                        onChangeCallback={handleHowManyQuantityVariantStepsSelection}
                        defaultValue={howManyQuantityVariantSteps}
                      />

                      </>
                  )}
                </Grid2>

            <Grid2 size={12}>
              <Divider sx={{ marginTop: '20px', marginBottom:'10px'}} />
              <Button 
                onClick={handleSaveVariation} 
                sx={{ width: '200px'}}
                disabled={!variantSelected || !selectedValue || !howManyQuantityVariantSteps}
              >
                Salvar
              </Button>
            </Grid2>
            </Grid2>
          ) : (
            <Grid2 sx={{ minWidth: '650px', padding: '30px 30px'}} >
                <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', ...titleStyle}} >{title}</Typography>

                <Grid2 size={12}>
                    <Grid2 size={12} sx={{ marginTop: '20px'}}>
                        <Button onClick={() => setNewVariation(true)} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} style={{  width: '200px'}} LeftIcon={() => <GoPlus size={18} />}>Nova Variação</Button> 
                    </Grid2>

                    <Divider sx={{ marginTop: '20px', marginBottom:'30px'}} />

                    <Typography sx={{ fontSize: '1.6rem', fontWeight: 'bold', ...titleStyle}} >Variações Existentes: </Typography>
                    
                    {variations.length === 0 ? (
                      <Typography sx={{ fontSize: '1rem', fontWeight: '400', ...titleStyle}} >Nenhuma variação cadastrada para este produto.</Typography>
                    ) : (
                      <Grid2 container spacing={2} sx={{ marginTop: '20px' }}>
                        {variations.map((variation, index) => (
                          <Grid2 size={12} key={index} sx={{ 
                            border: '1px solid #e0e0e0', 
                            borderRadius: '8px', 
                            padding: '15px',
                            marginBottom: '10px'
                          }}>
                            <Grid2 container alignItems="center" sx={{ gap: '10px' }}>
                              <Typography sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                                {variation.variationType}
                              </Typography>
                              <Button
                                onClick={() => handleRemoveVariationClick(variation.variationType)}
                                variant="text"
                                sx={{ minWidth: 'auto', padding: '5px', width: '50px', alignItems: 'center', justifyContent: 'center' }}
                                LeftIcon={() => <FaTrash size={14} color="#f44336" />}
                              >
                                {' '}
                              </Button>
                            </Grid2>
                            <Grid2 container spacing={1} sx={{ marginTop: '10px' }}>
                              {variation.values.map((value, valueIndex) => (
                                <Chip
                                  key={valueIndex}
                                  label={`Multiplicador: ${value} | Quantidade: ${variation.howManySteps}`}
                                  onDelete={() => handleRemoveValue(variation.variationType, value)}
                                  sx={{ fontSize: '12px', margin: '2px' }}
                                />
                              ))}
                            </Grid2>
                          </Grid2>
                        ))}
                      </Grid2>
                    )}
                  
                </Grid2>
                    </Grid2>
          )}
           </Drawer>
)
}

export { VariantsListDrawer }